import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import LaptopSkeletonIllustration from 'svg/illustrations/LaptopSkeleton';
// import AppleIcon from '@mui/icons-material/Apple';
// import PlayArrowRounded from '@mui/icons-material/PlayArrowRounded';
// import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'

const Hero = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const LeftSide = () => (
    <Box>
      <Box marginBottom={2}>
        <Typography component={'span'} variant="h4" sx={{ fontWeight: 700 }}>
          Elevate Your Urban Living Experience with{' '}

          <Typography
            component={'span'}
            variant={'h4'}
            color={'primary'}
            fontWeight={700}
          >
            Urban{' '}
          </Typography>
          <Typography
            component={'span'}
            variant={'h4'}
            color={'text.secondary'}
            fontWeight={700}
          // mr={2}
          >
            Resident
          </Typography>

          {' '}tailored for gated communities.
        </Typography>
      </Box>
      <Box marginBottom={2}>
        <Typography variant="h6" component="p" color={'text.secondary'}>
          Connect with your neighbors, manage your community, and engage in location-based social interactions, all within one app.
        </Typography>
      </Box>

      <Box width={130} display={'flex'} justifyContent={'space-between'}>
        <FontAwesomeIcon icon={['fab', 'app-store-ios']} size={'2xl'} color={theme.palette.text.secondary} />
        <FontAwesomeIcon icon={['fab', 'google-play']} size={'2xl'} color={theme.palette.text.secondary} />
        <FontAwesomeIcon icon={['fas', 'display']} size={'2xl'} color={theme.palette.text.secondary} />
      </Box>

      {/* <Box
        display="flex"
        flexWrap="wrap"
        justifyContent={'flex-start'}
        marginTop={4}
      >
        {[
          'https://assets.maccarianagency.com/svg/logos/airbnb-original.svg',
          'https://assets.maccarianagency.com/svg/logos/amazon-original.svg',
          'https://assets.maccarianagency.com/svg/logos/fitbit-original.svg',
          'https://assets.maccarianagency.com/svg/logos/netflix-original.svg',
        ].map((item, i) => (
          <Box maxWidth={70} marginTop={2} marginRight={4} key={i}>
            <Box
              component="img"
              height={1}
              width={1}
              src={item}
              alt="..."
              sx={{
                filter:
                  theme.palette.mode === 'dark'
                    ? 'brightness(0) invert(0.7)'
                    : 'contrast(0) brightness(0)',
              }}
            />
          </Box>
        ))}
      </Box> */}
    </Box>
  );

  return (
    <Grid container spacing={4}>
      <Grid item container alignItems={'center'} xs={12} md={6}>
        <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
          <LeftSide />
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            position: 'relative',
            marginX: 'auto',
            perspective: 1500,
            transformStyle: 'preserve-3d',
            perspectiveOrigin: 0,
          }}
        >
          <Box
            sx={{
              position: 'relative',
              marginX: 'auto',
              transform: 'rotateY(-35deg) rotateX(15deg) translateZ(0)',
              maxWidth: '96%',
            }}
          >
            <Box>
              <Box
                position={'relative'}
                zIndex={2}
                maxWidth={1}
                height={'auto'}
                sx={{ verticalAlign: 'middle' }}
              >
                <LaptopSkeletonIllustration />
              </Box>
              <Box
                position={'absolute'}
                top={'8.4%'}
                left={'12%'}
                width={'76%'}
                height={'83%'}
                border={`1px solid ${theme.palette.alternate.dark}`}
                zIndex={3}
              >
                <Box
                  component={'img'}
                  loading="lazy"
                  src="https://assets.maccarianagency.com/screenshots/dashboard.png"
                  alt="Image Description"
                  width={1}
                  height={1}
                  sx={{
                    objectFit: 'cover',
                    filter:
                      theme.palette.mode === 'dark'
                        ? 'brightness(0.7)'
                        : 'none',
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Hero;
